import React from 'react';
import * as Yup from 'yup';

import { Button } from 'components/_shared/Button';
import { FormField, FormFieldset } from 'components/_shared/Form';
import { Link } from 'components/_shared/Link';
import { ROUTES, FIELD_VALIDATION } from '_constants';
import {
  StyledMessage,
  ForgotPassLinkWrap,
  StyledLink,
  StyledForm
} from './AuthForm.styles';

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .required(FIELD_VALIDATION.REQUIRED)
    .max(150, 'Email cannot exceed 150 characters'),
  password: Yup.string()
    .trim()
    .min(8, 'Password must be at least 8 characters')
    .max(200, 'Password cannot exceed 200 characters')
    .required(FIELD_VALIDATION.REQUIRED)
});

export const AuthForm = ({ initialValues = {}, ...props }) => {
  const _initialValues = { email: '', password: '', ...initialValues };

  return (
    <StyledForm
      {...props}
      initialValues={_initialValues}
      validationSchema={validationSchema}
      header='Login'
      actions={[
        <Button key='submit' type='submit' variant='primary' fullWidth>
          Login
        </Button>
      ]}
    >
      <FormFieldset>
        <FormField
          label='Email'
          type='text'
          name='email'
          placeholder='example@gmail.com'
        />
        <FormField
          label='Password'
          type='password'
          name='password'
          placeholder='Enter password'
        />
        <ForgotPassLinkWrap>
          <StyledLink to={ROUTES.FORGOT_PASSWORD}>Forgot password?</StyledLink>
        </ForgotPassLinkWrap>
      </FormFieldset>
    </StyledForm>
  );
};
